var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLoupe = function SvgIconLoupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-Loupe_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.035 55.965 46.35 39.28A24.776 24.776 0 0 0 50.5 25.5c0-13.785-11.215-25-25-25s-25 11.215-25 25 11.215 25 25 25c4.945 0 9.686-1.432 13.78-4.15l4.612 4.612.002.002 12.07 12.071A4.967 4.967 0 0 0 59.5 64.5c1.335 0 2.59-.52 3.535-1.465A4.965 4.965 0 0 0 64.5 59.5c0-1.336-.52-2.591-1.465-3.535Zm-24.343-12.25v.001A22.307 22.307 0 0 1 25.5 48C13.094 48 3 37.907 3 25.5 3 13.094 13.094 3 25.5 3 37.907 3 48 13.094 48 25.5c0 4.772-1.481 9.333-4.284 13.192a22.61 22.61 0 0 1-5.024 5.024Zm2.623 1.134a25.087 25.087 0 0 0 3.534-3.534l3.547 3.546a30.34 30.34 0 0 1-3.535 3.535l-3.546-3.547Zm19.952 16.418c-.472.473-1.1.733-1.767.733-.667 0-1.295-.26-1.767-.733l-11.1-11.099a32.858 32.858 0 0 0 3.535-3.535l11.1 11.1c.472.472.732 1.1.732 1.767 0 .668-.26 1.295-.733 1.767Z",
    fill: "#FCFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 24.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 5.5c-11.028 0-20 8.972-20 20s8.972 20 20 20 20-8.972 20-20-8.972-20-20-20Zm0 37.5C15.85 43 8 35.15 8 25.5S15.85 8 25.5 8 43 15.85 43 25.5 35.15 43 25.5 43Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.508 20.134a15 15 0 0 0-5.42-6.927A14.894 14.894 0 0 0 25.5 10.5a1.25 1.25 0 0 0 0 2.5c5.137 0 9.829 3.227 11.675 8.03a1.25 1.25 0 1 0 2.333-.896Z",
    fill: "#14D64D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-Loupe_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h64v64H0z"
  })))));
};

export default SvgIconLoupe;